Vendd.Scripts.load(function () {

	var $wrapper = $('.x-category-list');

	if ($wrapper.length < 1)
		return;

	if ($wrapper.hasClass("js-lazyload") && typeof $.fn.lazyload === "function") {
		$wrapper.find("img[data-lazyload]").lazyload({
			effect: 'fadeIn',
			threshold: 50,
			skip_invisible: false
		}).removeAttr("data-lazyload");
	};
});